export const DEMO_OUTLETS = [
  {
    id: 1,
    outlet: 'Forbes',
    type: 'favourited',
    createdAt: '2025-01-15T10:00:00Z',
  },
  {
    id: 2,
    outlet: 'TechCrunch',
    type: 'favourited',
    createdAt: '2025-01-15T10:05:00Z',
  },
  {
    id: 3,
    outlet: 'Business Insider',
    type: 'tier1',
    createdAt: '2025-01-15T10:10:00Z',
  },
  {
    id: 4,
    outlet: 'The New York Times',
    type: 'favourited',
    createdAt: '2025-01-15T10:15:00Z',
  },
  {
    id: 5,
    outlet: 'Wired',
    type: 'tier1',
    createdAt: '2025-01-15T10:20:00Z',
  },
  {
    id: 6,
    outlet: 'Marketing Week',
    type: 'tier2',
    createdAt: '2025-01-16T09:00:00Z',
  },
  {
    id: 7,
    outlet: 'Search Engine Journal',
    type: 'blacklisted',
    createdAt: '2025-01-16T09:05:00Z',
  },
  {
    id: 8,
    outlet: 'Content Marketing Institute',
    type: 'tier2',
    createdAt: '2025-01-16T09:10:00Z',
  },
  {
    id: 9,
    outlet: 'Social Media Today',
    type: 'blacklisted',
    createdAt: '2025-01-16T09:15:00Z',
  },
  {
    id: 10,
    outlet: 'Entrepreneur',
    type: 'tier2',
    createdAt: '2025-01-16T09:20:00Z',
  },
  {
    id: 11,
    outlet: 'Inc. Magazine',
    type: 'tier2',
    createdAt: '2025-01-16T09:25:00Z',
  },
  {
    id: 12,
    outlet: 'Fast Company',
    type: 'favourited',
    createdAt: '2025-01-16T09:30:00Z',
  },
  {
    id: 13,
    outlet: 'The Globe and Mail',
    type: 'tier1',
    createdAt: '2025-01-16T09:35:00Z',
  },
  {
    id: 14,
    outlet: 'Vogue',
    type: 'blacklisted',
    createdAt: '2025-01-16T09:40:00Z',
  },
  {
    id: 15,
    outlet: 'HubSpot Blog',
    type: 'tier3',
    createdAt: '2025-01-17T10:00:00Z',
  },
  {
    id: 16,
    outlet: 'BuzzFeed',
    type: 'blacklisted',
    createdAt: '2025-01-17T10:05:00Z',
  },
  {
    id: 17,
    outlet: 'The Verge',
    type: 'favourited',
    createdAt: '2025-01-17T10:10:00Z',
  },
];

export const DEMO_ALL_OUTLETS = [
  'Forbes',
  'TechCrunch',
  'Business Insider',
  'The New York Times',
  'Wired',
  'Marketing Week',
  'Search Engine Journal',
  'Content Marketing Institute',
  'Social Media Today',
  'Entrepreneur',
  'Inc. Magazine',
  'Fast Company',
  'The Globe and Mail',
  'Vogue',
  'HubSpot Blog',
  'BuzzFeed',
  'The Verge',
  'Moz Blog',
  'AdWeek',
  'MarketingProfs',
  'CMSWire',
  'Digital Marketing Magazine',
];
